import { branch, renderComponent } from 'react-recompose';
import { SkeletonListLoader } from '../loaders/skeleton-list-loader';

export default (propName = 'loading') => {
  return branch(
    props => props[propName],
    renderComponent(() => <SkeletonListLoader items={14} />),
  );
};
